/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSavingsActiveInputs} from '../api'

 export const useQueryGetSavingsActiveInputs = createReactQueryHook('getSavingsActiveInputs', getSavingsActiveInputs)
